import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/statistics/Index/industryRanking",{
        params: {
            ...params
        }
    } )
}
function EXPORT(params) {
    return  axios.get("/statistics/Index/industryRankingExport",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
